<div
  [ngClass]="adContainerCssClass()"
  class="mt-12 md:mt-3 w-full max-w-full relative -mb-3"
>
  @if (isDesktopAdVisible()) {
    <app-standard-dfp-banner-loader
      [isFluid]="true"
      [reloadCallback]="onBannerReload"
      [showAdLabel]="false"
      [size]="[[720,540]]"
      [unitName]="'/56297020/SERVICE_TYPE_PAGE_720x540'"
    ></app-standard-dfp-banner-loader>
  }
  @if (isMobileAdVisible()) {
    <app-standard-dfp-banner-loader
      [isFluid]="true"
      [reloadCallback]="onBannerReload"
      [showAdLabel]="false"
      [size]="[[380,285]]"
      [unitName]="'/56297020/SERVICE_TYPE_PAGE_RESPONSIVE_380x285'"
    ></app-standard-dfp-banner-loader>
  }
</div>
